import * as z from "zod";
import { createFormHook, useSelector, type AnyFieldApi } from "@tanstack/react-form";
import { lazy, useMemo } from "react";
import { fieldContext, formContext } from "./contexts/formContext";

const components = {
	TextField: lazy(() => import("@/components/TanStack/TextField")),
	NumberField: lazy(() => import("@/components/TanStack/NumberField")),
	DateRangeField: lazy(() => import("@/components/TanStack/DateRangeField")),
	SelectField: lazy(() => import("@/components/TanStack/SelectField")),
	UnitSelect: lazy(() => import("@/components/TanStack/UnitSelectField")),
	ChainSelectorField: lazy(
		() => import("@/components/TanStack/ChainSelectorField"),
	),
};

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
	fieldComponents: components,
	formComponents: {
		SubscribeButton: lazy(
			() => import("@/components/TanStack/SubscribeButton.tsx"),
		),
	},
	fieldContext,
	formContext,
});

export { useSelector } from "@tanstack/react-form";

export interface FormProps<T extends z.ZodType> {
	readonly id?: string;
	readonly defaultValue: z.infer<T>;
	readonly onSubmit: (data: z.infer<T>) => void;
}
export function onSubmit(form: {
	handleSubmit: (e: React.SubmitEvent) => Promise<void>;
}) {
	return (e: React.SubmitEvent) => {
		e.preventDefault();
		void form.handleSubmit(e);
	};
}

export function useFieldErrors(store: AnyFieldApi) {
	const errors = useSelector(
		store.store,
		(state) => state.meta.errors as Array<string | z.core.$ZodIssue>,
	);

	const mapped = useMemo(() => {
		return errors.map((error) => {
			if (typeof error === "string") {
				return error;
			} else {
				const message = (error.message as string | null);
				return message ?? "Error desconocido";
			}
		});
	}, [errors]);
	return mapped;
}
